import { AfterViewInit, Directive, ElementRef, HostBinding, Input, OnInit } from '@angular/core';
import { ReorderableColumn, ResizableColumn, SortableColumn } from 'primeng/table';
import { TableColumnConfiguration } from '../avano-table.model';

/**
 * Here we basically add a different selector to pSortableColumn, pResizableColumn and pReorderableColumn
 * This allowes us to use those directives and their inputs with way fewer lines
 * CAUTION: Needs to be double-checked after each primeNG update, as we have to reuse some primeNG logic to make them work
 * - setting attribute for pReorderableColumn is required, since primeNG reorderable logic looks for that one in th-elements
 * - if lifecycle hooks are overwritten, be sure to call super at some point.
 */
@Directive({
  selector: '[avanoTableColumnHeader]'
})
export class CustomPSortable extends SortableColumn implements OnInit {
  @Input('avanoTableColumnHeader') readonly column: TableColumnConfiguration = null;

  ngOnInit(): void {
    if(this.column) {
      this.pSortableColumnDisabled = this.column.sortable === false
      this.field = this.column.sortable === false ? null : (this.column.sortField ?? this.column.field)
    }
    super.ngOnInit()
  }
}

@Directive({
  selector: '[avanoTableColumnHeader]'
})
export class CustomPResizable extends ResizableColumn implements AfterViewInit {
  @HostBinding('attr.presizablecolumn') readonly setAttribute = true;
}

@Directive({
  selector: '[avanoTableColumnHeader]'
})
export class CustomPReordable extends ReorderableColumn implements AfterViewInit {
  @HostBinding('attr.preorderablecolumn') readonly setAttribute = true;
}


/**
 * This directive initializes the width of table-columns (headers and cells), and updates "last-resizable" class
 */
@Directive({
  selector: '[avanoTableColumnHeader], [avanoTableCell]'
})
export class AvanoResizableColumn implements AfterViewInit {
  @Input('avanoTableColumnHeader') readonly columnHeaderInput: TableColumnConfiguration = null;
  @Input('avanoTableCell') readonly columnBodyInput: TableColumnConfiguration = null;
  get column() { return this.columnHeaderInput ?? this.columnBodyInput };

  constructor(private el: ElementRef){}
  
  @Input() set isLastSortable(isLast: boolean) {
    const nativeHtmlElement = this.el.nativeElement as HTMLElement;
    if (isLast) {
      nativeHtmlElement.classList.add('last-resizable');
    } else {
      nativeHtmlElement.classList.remove('last-resizable');
    }
  }
  ngAfterViewInit(): void {
    const nativeElement = this.el.nativeElement as HTMLElement;
    nativeElement.style.minWidth = this.column?.minWidth ?? '50px';
    if(this.column.width) {
      const isFlex = window.getComputedStyle(nativeElement.parentElement).display === 'flex';
      if (isFlex) {
        nativeElement.classList.add('flex-with-width')
      }
      nativeElement.style.width = this.column.width;
    }
  }
}
